<div class="spinner" [class.spinner--fill]="fill" [ngStyle]="colorVars">
  <p-progressspinner
    [style]="{ width: dimension, height: dimension }"
    [strokeWidth]="strokeWidth.toString()"
    ariaLabel="Loading" />
  <span *ngIf="label" class="spinner__label">{{ label }}</span>
</div>
